// Fix for cart count not updating after quick add
(function() {
  // Listen for all cart:update events to ensure cart drawer and count update
  document.addEventListener('cart:update', async function(event) {
    // If event has cart data, use it
    const cart = event.detail?.resource;

    if (cart) {
      // Update cart icon manually if needed
      const cartIcon = document.querySelector('cart-icon');
      if (cartIcon && cartIcon.renderCartBubble) {
        cartIcon.renderCartBubble(cart.item_count || 0, false, true);
      }

      // Open cart drawer if auto-open is enabled
      const cartDrawer = document.querySelector('cart-drawer-component[auto-open]');
      if (cartDrawer) {
        if (cartDrawer.showDialog) {
          cartDrawer.showDialog();
        } else if (cartDrawer.open) {
          cartDrawer.open();
        }
      }
    }
  });

  // Override fetch to intercept cart add operations
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    const [url, options] = args;

    // Intercept cart add requests
    if (typeof url === 'string' && url.includes('/cart/add')) {
      return originalFetch.apply(this, args).then(async response => {
        // Clone response to read it without consuming
        const clonedResponse = response.clone();

        try {
          const data = await clonedResponse.json();

          // If add was successful, fetch updated cart and dispatch events
          if (response.ok && !data.status) {
            setTimeout(async () => {
              const cartResponse = await originalFetch('/cart.js');
              const cart = await cartResponse.json();

              // Dispatch cart update event
              const cartUpdateEvent = new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: cart,
                  data: {
                    itemCount: cart.item_count,
                    source: 'quick-add-fix'
                  }
                }
              });
              document.dispatchEvent(cartUpdateEvent);

              // Update cart icon
              const cartIcon = document.querySelector('cart-icon');
              if (cartIcon) {
                if (cartIcon.renderCartBubble) {
                  cartIcon.renderCartBubble(cart.item_count || 0, false, true);
                } else {
                  // Fallback: update text directly
                  const cartCount = cartIcon.querySelector('.cart-bubble__text-count');
                  if (cartCount) {
                    cartCount.textContent = cart.item_count || '0';
                  }
                }
              }

              // Open cart drawer
              const cartDrawer = document.querySelector('cart-drawer-component[auto-open]');
              if (cartDrawer) {
                if (cartDrawer.showDialog) {
                  cartDrawer.showDialog();
                } else if (cartDrawer.open) {
                  cartDrawer.open();
                }
              }
            }, 100);
          }
        } catch (e) {
          // Ignore JSON parse errors for non-JSON responses
        }

        return response;
      });
    }

    return originalFetch.apply(this, args);
  };

  // Also listen for form submissions
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (form.action && form.action.includes('/cart/add')) {
      // Form will be handled by product-form.js, but ensure cart updates
      setTimeout(async () => {
        try {
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();

          // Update cart icon
          const cartIcon = document.querySelector('cart-icon');
          if (cartIcon && cartIcon.renderCartBubble) {
            cartIcon.renderCartBubble(cart.item_count || 0, false, true);
          }
        } catch (error) {
          console.error('Error updating cart:', error);
        }
      }, 500);
    }
  });
})();